// extracted by mini-css-extract-plugin
export default {"step":"map_step__iQs4i","title":"map_title__kJfPw","description":"map_description__I+gzz"};